import { createEvent } from 'effector'

// https://withease.pages.dev/magazine/explicit_start
export const appStarted = createEvent()
